import { programTypes } from '../../types'
import { reduxTypes } from '../types'

function update(program: programTypes.Program) {
  return {
    payload: program,
    type: reduxTypes.PROGRAM_UPDATE,
  }
}

export default {
  update,
}
